import React, { useRef } from "react";
import { useScrollReveal } from "../hooks";

const DIFFS = [
  {
    n: "01",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"/>
      </svg>
    ),
    title: "Business before trends.",
    body: "We don't chase what's popular. We build what works for your specific business, market and audience.",
  },
  {
    n: "02",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M9 11l3 3L22 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    title: "Strategy before execution.",
    body: "We never pick up a camera or write a line of code without a clear reason. Every action has a purpose.",
  },
  {
    n: "03",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M3 17l4-6 4 4 4-7 4 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <circle cx="19" cy="13" r="2" stroke="currentColor" strokeWidth="1.3"/>
      </svg>
    ),
    title: "Growth before vanity.",
    body: "Likes and followers are nice. Leads, customers and revenue are the metrics that actually matter.",
  },
];

export default function Differentiator() {
  const ref = useRef(null);
  const visible = useScrollReveal(ref);

  return (
    <section id="differentiator" className={"section section-border reveal-section" + (visible ? " revealed" : "")} ref={ref}>
      <div className="container">
        <div className="df-head">
          <span className="eyebrow">Why OVARD</span>
          <h2 className="h2" style={{ marginTop: 16, maxWidth: 560 }}>
            We work differently. Here's what that means in practice.
          </h2>
        </div>
        <div className="df-stack">
          {DIFFS.map((d, i) => (
            <div className="df-row reveal-child" style={{ transitionDelay: `${i * 0.12}s` }} key={d.n}>
              <span className="df-num">{d.n}</span>
              <div className="df-content">
                <span className="df-icon">{d.icon}</span>
                <h3 className="df-title">{d.title}</h3>
                <p className="df-body">{d.body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
